import gql from 'graphql-tag'

export default gql`
query queryAdHocServiceAvailableTimes(
  $adHocServiceId: ID!
  $ignoreAppointmentId: ID
) {
  adHocServiceAvailableTimes(
    adHocServiceId: $adHocServiceId
    ignoreAppointmentId: $ignoreAppointmentId
  ) {
    times
  }
}
`
